import { Box } from '@mui/material';
import { EstadoAvisoObraEnum, getEstadoAvisoObraLabel } from '../../consts/avisoObraStatesTypes';

interface StateBadgeAvisoObraProps {
    state: EstadoAvisoObraEnum | number;
    text?: string;
    hideIcon?: boolean;
}

const StateBadgeAvisoObra = ({ state, text, hideIcon }: StateBadgeAvisoObraProps) => {
    let bgColor = '';
    let textColor = '';
    const label = text || getEstadoAvisoObraLabel(state);

    switch (state) {
        case EstadoAvisoObraEnum.EN_REVISION:
            bgColor = '#DFF2FF';
            textColor = '#2578B8';
            break;
        case EstadoAvisoObraEnum.PENDIENTE_VISITA:
            bgColor = '#EAE5FB';
            textColor = '#7E57C2';
            break;
        case EstadoAvisoObraEnum.PRESENTADO:
            bgColor = '#E1F5E3';
            textColor = '#2E7D32';
            break;
        case EstadoAvisoObraEnum.RECIBIDO:
            bgColor = '#FFF8E1';
            textColor = '#FFA000';
            break;
        case EstadoAvisoObraEnum.BORRADOR:
            bgColor = '#ECEFF1';
            textColor = '#37474F';
            break;
        case EstadoAvisoObraEnum.CANCELADO:
            bgColor = '#FFEBEE';
            textColor = '#D32F2F';
            break;
        case EstadoAvisoObraEnum.FINALIZADO:
            bgColor = '#E1F5E3';
            textColor = '#388E3C';
            break;
        case EstadoAvisoObraEnum.SUSPENDIDO:
            bgColor = '#EEEEEE';
            textColor = '#424242';
            break;
        case EstadoAvisoObraEnum.EN_EXTENSION:
            bgColor = '#E3F2FD';
            textColor = '#1976D2';
            break;
        case EstadoAvisoObraEnum.A_REVISAR:
            bgColor = '#FBE9E7';
            textColor = '#E64A19';
            break;
        default:
            bgColor = '#F5F5F5';
            textColor = '#9E9E9E';
            break;
    }

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: bgColor,
                padding: '4px 12px',
                borderRadius: '16px',
                fontWeight: 600,
                color: textColor,
                fontSize: '0.875rem',
                textTransform: 'capitalize'
            }}
        >
            {!hideIcon && <span style={{ marginRight: 4 }}>●</span>}
            {label}
        </Box>
    );
};

export default StateBadgeAvisoObra;
